import { IconButton, IconButtonProps } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';

function ClearSearchButton(props: IconButtonProps) {
    return (
        <IconButton aria-label="Clear Search" sx={{ padding: 0 }} {...props}>
            <CloseRounded sx={{ color: 'cement.500' }} />
        </IconButton>
    );
}

export default ClearSearchButton;
